
import {isMobileApp} from './Util';
import FactfinderSuggest from './FactfinderSuggest'


class PluscardApp {

	constructor() {
		if ( isMobileApp() ) {
			window.addEventListener( 'message', ( nativeEvent ) => this.onMessage( nativeEvent?.data ) );
		}
	}

	onMessage( message ) {
		try {
			const { type, action, payload } = JSON.parse( message ); // eslint-disable-line no-unused-vars
			if ( 'pluscard-app' === type ) {
				switch ( action ) {
					case 'open-search':
						this.openSearch();
						break;
					case 'close-search':
						this.closeSearch();
						break;
					case 'open-menu':
						this.openMenu();
						break;
					case 'close-menu':
						this.closeMenu();
						break;
				}
			}
		} catch ( err ) {
			// Not error needed.
		}
	}

	onBackButtonClick() {
		if ( isMobileApp() && 'ReactNativeWebView' in window ) {
			window.ReactNativeWebView.postMessage( 'navigation::back' );
		} else {
			window.history.back();
		}
	}

	openMenu() {
		const menuEl = document.getElementById( 'menu_mobile' );
		menuEl.classList.add( 'is-open' );
	}

	closeMenu() {
		const menuEl = document.getElementById( 'menu_mobile' );
		menuEl.classList.remove( 'is-open' );
	}

	openSearch() {
		const searchEl = document.querySelector( '.mdl_search' );
		const instance = FactfinderSuggest.getInstance( searchEl )
		instance?.open();
	}

	closeSearch() {
		const searchEl = document.querySelector( '.mdl_search' );
		const instance = FactfinderSuggest.getInstance( searchEl )
		instance?.close();
	}
}


const PluscardAppHandler = new PluscardApp();
const initPluscardApp = ( scopeEl = document ) => {
	const buttonEl = scopeEl.getElementById( 'koegs_navigation_back' );
	if ( buttonEl ) {
		buttonEl.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			PluscardAppHandler.onBackButtonClick();
		} );
	}
}


export {
	PluscardAppHandler as default,
	initPluscardApp
};
